// Be VERY careful touching this line.
import { GlobalWorkerOptions, version, getDocument } from "pdfjs-dist/build/pdf.min.js"
// Be VERY careful touching this line.
const workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.min.js`
// Be VERY careful touching this line.
GlobalWorkerOptions.workerSrc = workerSrc

const RASTER_UPSCALING_MULTIPLIER = 2.5

export const rasterizePDF = async (data: ArrayBuffer | Uint8Array) => {
    const loadingTask = getDocument({ data })
    const pdfDocument = await loadingTask.promise
    const page = await pdfDocument.getPage(1)
    const viewport = page.getViewport({ scale: RASTER_UPSCALING_MULTIPLIER })

    const canvas = document.createElement("canvas")
    canvas.width = viewport.width
    canvas.height = viewport.height
    const context = canvas.getContext("2d")!

    await page.render({ canvasContext: context, viewport }).promise

    return context.getImageData(0, 0, canvas.width, canvas.height)
}
